import logo from "./logo.jpeg";
import whiteLogo from "./whiteLogo.jpeg";
import Roshetaa from "./Roshetaa.png";

import spinner from "./spin.mpeg";
import win from "./win.mpeg";

export { logo, whiteLogo, spinner, win, Roshetaa };
